import { NavItem, FooterNavGroup } from '../types';

/**
 * Main navigation items for the header navbar
 */
export const mainNavItems: NavItem[] = [
  { name: 'Services', path: 'services' },
  { name: 'Solutions', path: 'solutions' },
  { name: 'About', path: 'about' },
  { name: 'Contact', path: 'contact' }
];

/**
 * Footer navigation groups
 */
export const footerNavGroups: FooterNavGroup[] = [
  {
    title: 'Company',
    links: [
      { name: 'About', path: 'about' },
      { name: 'Services', path: 'services' },
      { name: 'Team', path: 'team' },
      { name: 'Features', path: 'features' }
    ]
  },
  {
    title: 'Resources',
    links: [
      { name: 'Solutions', path: 'solutions' },
      { name: 'Process', path: 'process' },
      { name: 'FAQ', path: 'faq' },
      { name: 'Contact', path: 'contact' }
    ]
  }
];

/**
 * Legal/footer links
 */
export const legalLinks: NavItem[] = [
  { name: 'Privacy Policy', path: '/privacy-policy', external: false },
  { name: 'Terms of Service', path: '/terms-of-service', external: false }
];